// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let DeleteQuestionEditor
export default DeleteQuestionEditor = (function () {
  DeleteQuestionEditor = class DeleteQuestionEditor extends (
    require("lib/static-shim").default(
      require("assessments/admin/views/question-editor").default
    )
  ) {
    static initClass() {
      this.prototype.template = require("./templates/delete-question.html")

      this.prototype.triggers = { "click button.delete": "deleteQuestion" }
    }

    onDeleteQuestion() {
      //@model.collection?.remove(@model)
      return this.model.destroy()
    }
  }
  DeleteQuestionEditor.initClass()
  return DeleteQuestionEditor
})()
